var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrategy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16668 2.33398C4.94502 2.33398 2.33334 4.94566 2.33334 8.16732V19.834C2.33334 23.0556 4.94502 25.6673 8.16668 25.6673H19.8333C23.055 25.6673 25.6667 23.0556 25.6667 19.834V8.16732C25.6667 4.94566 23.055 2.33398 19.8333 2.33398H8.16668ZM15.1667 9.33398C15.1667 8.68965 14.6443 8.16732 14 8.16732C13.3557 8.16732 12.8333 8.68965 12.8333 9.33398V18.6673C12.8333 19.3117 13.3557 19.834 14 19.834C14.6443 19.834 15.1667 19.3117 15.1667 18.6673V9.33398ZM9.33334 11.6673C9.97768 11.6673 10.5 12.1897 10.5 12.834V18.6673C10.5 19.3117 9.97768 19.834 9.33334 19.834C8.68901 19.834 8.16668 19.3117 8.16668 18.6673V12.834C8.16668 12.1897 8.68901 11.6673 9.33334 11.6673ZM18.6667 14.0007C19.311 14.0007 19.8333 14.523 19.8333 15.1673V18.6673C19.8333 19.3117 19.311 19.834 18.6667 19.834C18.0223 19.834 17.5 19.3117 17.5 18.6673V15.1673C17.5 14.523 18.0223 14.0007 18.6667 14.0007Z",
    fill: "#6D57DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.b7bc071c9210131c98ab57be306c9d2e.svg";
export { ForwardRef as ReactComponent };